import React from 'react';
import { FormattedTag, FormattedHTMLMessageSecure } from 'core/components';
import { Main } from 'components/main/main';
import { HeadHelmet } from 'components/head-helmet/head-helmet';

import { PAGE_NAMES } from '../../constants';

const UnderageGaming = () => (
  <Main className="text-markup-container">
    <HeadHelmet page={PAGE_NAMES.UNDERAGE_GAMING} />

    <div className="text-markup-inner">
      <FormattedTag
        id="underage-gaming.title"
        className="text-markup-title text-switch-white"
      />

      <div className="text-markup-content">
        <FormattedHTMLMessageSecure id="underage-gaming.content" />
      </div>
    </div>
  </Main>
);

export default UnderageGaming;
